import DragController from 'components/drag-controller/DragController';
import Component from 'navigation/component/Component';
export default class ProductBreadcrumbs extends Component {
    getModulesMap() {
        return {
            dragController: ['.product__breadcrumbs-inner', DragController]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            gradient: true
        };
    }
}
